import { AgentLanguage } from '../agent-language'

const betaRules: { readonly [key: string]: AgentLanguage[] } = {
  csrf: [
    AgentLanguage.DOTNET,
    AgentLanguage.JAVA,
    AgentLanguage.NODE,
    AgentLanguage.RUBY,
    AgentLanguage.PYTHON
  ],
  'nosql-injection': [
    AgentLanguage.NODE,
    AgentLanguage.RUBY,
    AgentLanguage.PYTHON
  ],
  'unsafe-file-upload': [
    AgentLanguage.NODE,
    AgentLanguage.RUBY,
    AgentLanguage.JAVA,
    AgentLanguage.DOTNET,
    AgentLanguage.DOTNET_CORE,
    AgentLanguage.PYTHON
  ],
  'ognl-injection': [AgentLanguage.JAVA],
  'padding-oracle': [AgentLanguage.JAVA],
  redos: [AgentLanguage.JAVA],
  'ssjs-injection': [AgentLanguage.NODE],
  ssrf: [AgentLanguage.RUBY],
  'untrusted-deserialization': [AgentLanguage.RUBY],
  'zip-file-overwrite': [AgentLanguage.JAVA],
  'signature-tampering': [AgentLanguage.JAVA]
}

export function getIsBetaRule(rule: string, language: AgentLanguage) {
  const betaRule = betaRules[rule]

  if (!betaRule) {
    return false
  }

  return betaRule.includes(language)
}
